<script setup lang="ts">
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'ScoutsLogo',
})
</script>

<template>
    <img class="logo" alt="Space Scouts, Космические Скауты" :src="`/img/page/landing/logo.png`">
</template>

<style scoped lang="scss">
.logoHolder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
}

.logo {
    position: relative;
    width: 100%;
    max-width: 550px;
}
</style>
